module.exports = __webpack_public_path__ + "img/accents-and-decor.9e5c266.png";